const React = require('react')

class AlertHeading extends React.PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      isMount: false,
    }
  }

  componentDidMount() {
    this.setState({isMount: true})
  }

  render() {
    // need to update role only after mounting for NVDA
    const role = this.state.isMount ? 'alert' : undefined
    return (
      <h2 role={role} {...this.props}>
        {this.props.children}
      </h2>
    )
  }
}

module.exports = AlertHeading
